import React from "react";
import {Popover} from "@mui/material";
import styled from 'styled-components'
import {useTranslation} from "react-i18next";
export const RowPopOverList = ({list, target, isAdd, onChangeTagName,width= 240, onClose})=>{
    const {t} = useTranslation()

    const handleChangeTagName = val=>{
        if(onChangeTagName)
            onChangeTagName(val)
        onClose()

    }
    return(
        <Popover
            className="common-popover"
            open={target}
            anchorEl={target}
            onClose={onClose}
            anchorOrigin={{
                vertical: isAdd ? 'top' : 'start',
                horizontal: isAdd ? 'right' : 'top',
            }}
            transformOrigin={{
                vertical: isAdd ? 'top' : 'bottom',
                horizontal: isAdd ? 'left' : 'start',
            }}
        >
            <StyledRowMenuPopOverV2>
                <div style={{width: `${width}px`}}>
                    {
                        list?.length > 0 && list?.map((item, key) => {
                            return (
                                <li
                                    key={key}
                                    className="row-menu-popover__item"
                                    onClick={() => handleChangeTagName(t(item?.name))}
                                >
                                    <span>{t(item?.name)}</span>
                                </li>
                            )
                        })
                    }
                </div>
            </StyledRowMenuPopOverV2>
        </Popover>
    )
}
const StyledRowMenuPopOverV2 = styled.div`
  .row-menu-popover {
    &__item {
       height: 48px;
      padding: 8px 12px;
      display: flex;
      align-items: center;

      color: #00081d;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;

      transition: color 0.25s;

      cursor: pointer;
      &:hover {
          background-color: #f3f6fc;
       }
    }   
  }
`